import { render, staticRenderFns } from "./ShopCourseItem.vue?vue&type=template&id=9d0de478&"
import script from "./ShopCourseItem.vue?vue&type=script&lang=js&"
export * from "./ShopCourseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports